import { render, staticRenderFns } from "./TableDeliver.vue?vue&type=template&id=677bb8a4"
import script from "./TableDeliver.vue?vue&type=script&lang=js"
export * from "./TableDeliver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports